var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "orders-list", attrs: { "data-cy": "order-list" } },
    [
      !_vm.statusPending
        ? _c(
            "div",
            {
              staticClass: "list-group",
              attrs: { "data-cy": "order-list-items" }
            },
            [
              _vm._l(_vm.sortedOrders, function(order) {
                return _c(
                  "div",
                  {
                    key: order.id,
                    staticClass: "list-group-item",
                    attrs: { "data-cy": "order-list-item" },
                    on: {
                      click: function($event) {
                        return _vm.orderSelected(order)
                      }
                    }
                  },
                  [
                    _c(
                      "div",
                      {
                        staticClass: "orders-list__order-status",
                        class: {
                          pending: !order.completed,
                          canceled: _vm.isOrderCanceled(order)
                        }
                      },
                      [
                        _c("i", {
                          staticClass: "fa",
                          class: _vm.orderIcon(order)
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c("div", { staticClass: "orders-list__order-summary" }, [
                      _c("div", { staticClass: "orders-list__order-heading" }, [
                        _c("h2", { staticClass: "orders-list__order-title" }, [
                          _vm._v(
                            "\n            " +
                              _vm._s(_vm.orderItemTitle(order)) +
                              "\n          "
                          )
                        ]),
                        _vm._v(" "),
                        _c(
                          "span",
                          { staticClass: "orders-list__order-timestamp" },
                          [_vm._v(_vm._s(_vm.getDate(order.startTime)))]
                        )
                      ]),
                      _vm._v(" "),
                      _c(
                        "p",
                        {
                          staticClass: "orders-list__order-preview",
                          attrs: { "data-cy": "order-list-item-status" }
                        },
                        [
                          _vm._v(
                            "\n          " +
                              _vm._s(_vm.orderStatus(order)) +
                              "\n        "
                          )
                        ]
                      )
                    ])
                  ]
                )
              }),
              _vm._v(" "),
              _vm.sortedOrders.length == 0
                ? _c("div", {
                    directives: [
                      {
                        name: "t",
                        rawName: "v-t",
                        value: "NO_ORDERS_FOUND",
                        expression: "'NO_ORDERS_FOUND'"
                      }
                    ],
                    staticClass: "orders-list__not-found"
                  })
                : _vm._e()
            ],
            2
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.statusPending
        ? _c(
            "div",
            { staticClass: "p-t-10" },
            [
              _c("Loader"),
              _vm._v(" "),
              _c("span", {
                directives: [
                  {
                    name: "t",
                    rawName: "v-t",
                    value: "ORDERS_LOADING",
                    expression: "'ORDERS_LOADING'"
                  }
                ]
              })
            ],
            1
          )
        : _vm._e()
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }